import React from "react"
import {
  BodyText,
  InlineText,
  SubTitle,
  Title,
} from "../../Typography/Typography"
import SmartLink from "../../layout/SmartLink/SmartLink"
import LineBreak from "../../LineBreak/LineBreak"

const providerProfileClickEvent = () => ({
  name: "SEO Filtered Directory - Copy link to provider clicked",
  properties: {
    "Care Type": "care_home",
    "GEO Location": "Bristol",
    "Current URL":
      "https://www.caresourcer.com/s/providers/towns/bristol/care-home/",
  },
})

export default {
  title: (
    <Title marginBottom>
      Finding the Right Care Home for Your Loved One in Bristol
    </Title>
  ),
  summary: (
    <BodyText marginBottom>
      If you are a care searcher looking for the best care home for your loved
      one in the South West’s cultural capital of Bristol, CareSourcer’s premium
      care provider offerings should have the answer for you.
      <LineBreak />
      <LineBreak />
      Choosing the perfect care home for a loved one can feel like a huge task -
      with many care searchers unsure as to how to begin the search process.
      <LineBreak />
      <LineBreak />
      Our care home directory features 10 premium care homes in Bristol, which
      all offer a range of specialisms.
      <LineBreak />
      <LineBreak />
      We hope our care directory helps you find the right care home for your
      loved one.
    </BodyText>
  ),
  content: [
    <SubTitle marginBottom bold>
      Treating the person, not the condition
    </SubTitle>,
    <BodyText marginBottom>
      Druid Stoke Care Home in Stoke Bishop says they prefer to treat the
      person, not the condition.
      <LineBreak />
      <LineBreak />
      The care home says their care emphasises respect, dignity and quality of
      life.
      <LineBreak />
      <LineBreak />
      Residents receive 24-hour support from the team of registered nurses and
      highly trained care assistants. Druid Stoke aims to provide the right
      level of care, while ensuring residents keep as much independence as
      possible.
    </BodyText>,
    <SubTitle marginBottom bold>
      Good for the soul
    </SubTitle>,
    <BodyText marginBottom>
      To have a happy home, it needs to be more than just four walls - you need
      to feel at ease and peaceful in your own space.
      <LineBreak />
      <LineBreak />
      <SmartLink
        to="https://www.caresourcer.com/uk/providers/cqc/1-117976955/hartcliffe-nursing-home"
        newTab
        clickEvent={providerProfileClickEvent()}
      >
        <InlineText brand>Hartcliffe Nursing Home </InlineText>
      </SmartLink>
      says they are a calm and welcoming home, whose team deliver personalised
      care to the 65 residents they can provide for in a supportive and safe
      environment.
      <LineBreak />
      <LineBreak />
      As a community-focused care home, Hartcliffe has created an environment
      for residents and day centre members to feel at home.
      <LineBreak />
      <LineBreak />
      Hartcliffe offers a number of opportunities to enable residents to foster
      relationships and positive experiences - whether through creative pursuits
      and trips out or by developing new skills and fulfilling personal
      ambitions.
    </BodyText>,
    <SubTitle marginBottom bold>
      Activities galore
    </SubTitle>,
    <BodyText marginBottom>
      If your loved one likes to stay active and engaged, choosing a care home
      with a wide array of activities on their doorstep should be on your list.
      <LineBreak />
      <LineBreak />
      <SmartLink
        to="https://www.caresourcer.com/uk/providers/cqc/1-279387067/horfield-lodge"
        newTab
        clickEvent={providerProfileClickEvent()}
      >
        <InlineText brand>Horfield Lodge </InlineText>
      </SmartLink>{" "}
      is one such care home, providing residential and dementia residential care
      to residents.
      <LineBreak />
      <LineBreak />
      Not only does Horfield Lodge offer landscaped gardens, an on-site hair
      salon and coffee shop - the residential home also has award-winning music
      therapy available too.
      <LineBreak />
      <LineBreak />
      Horfield’s music therapy helps alleviate isolation and the symptoms for
      those living with dementia. The award-winning therapist (funded by
      charitable donations) interacts with residents through live music therapy
      sessions including singing, playing simple percussion instruments or
      responding to musical cues in a one-to-one or group setting.
      <LineBreak />
      <LineBreak />
      <SmartLink
        to="https://www.caresourcer.com/uk/providers/cqc/1-2513151759/bishopsmead-lodge"
        newTab
        clickEvent={providerProfileClickEvent()}
      >
        <InlineText brand>Bishopsmead Lodge Care Home </InlineText>
      </SmartLink>{" "}
      also boasts a busy activities programme for residents to enjoy, including
      visiting entertainers, arts and crafts, cooking, music and shared
      activities with the local community including the nearby bowling club.
      <LineBreak />
      <LineBreak />
      Bishopsmead Lodge is situated in a residential area, overlooking Kings
      Head Lane Park and the local bowling club.
    </BodyText>,
  ],
  ourExpectCareGuide: [
    <SubTitle marginBottom bold>
      Our expert care guide
    </SubTitle>,
    <BodyText marginBottom>
      If you aren’t ready to make a decision yet, and would like a little more
      detailed advice on best practices in choosing the best care home for your
      loved one, you can
      <SmartLink
        to="https://www.caresourcer.com/guide-to-finding-the-right-care-home/"
        newTab
        clickEvent={providerProfileClickEvent()}
      >
        <InlineText brand> download our expert guide. </InlineText>
      </SmartLink>
      <LineBreak />
      <LineBreak />
      Written by one of our very own UK care experts, the guide focuses on
      understanding regulatory ratings, reading between the lines in reviews and
      the questions you should ask prospective care homes when you call to
      enquire.
    </BodyText>,
  ],
}
